import { Component, OnInit, EventEmitter, Input, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { WaitlistModel } from 'src/app/core/models/waitlist-model';

@Component({
  selector: 'app-waitlist-item',
  templateUrl: './waitlist-item.component.html',
  styleUrls: ['./waitlist-item.component.scss']
})

export class WaitlistItemComponent implements OnInit {

  @Input() waitlistItem: WaitlistModel;
  @Output() delete: EventEmitter<any> = new EventEmitter();
  @Output() edit: EventEmitter<any> = new EventEmitter();
  @Output() createAppt: EventEmitter<any> = new EventEmitter();

  public STATUS_VACANT: number;

  constructor(private translate: TranslateService) {
    this.STATUS_VACANT = 2;
  }

  ngOnInit() {
  }

  onCreateAppointment(waitlistItem: WaitlistModel) {
    this.createAppt.emit(waitlistItem);
  }

  onEdit(waitlistItem: WaitlistModel) {
    this.edit.emit(waitlistItem);
  }

  onDelete(waitlistItem: WaitlistModel) {
    this.delete.emit(waitlistItem);
  }

}
